/**
 * US-049 — GENERATED per-resource write→read implications (49 pairs).
 * Source of truth: backend/scripts/us049-derivation.json.
 * DO NOT EDIT BY HAND — regenerate with: npx tsx backend/scripts/gen-catalog.ts
 *
 * The 37 elevated action keys are intentionally NOT implied by `:write`
 * (reclassification §3.2 non-implication rule — e.g. medication:write does NOT
 * grant medication:administer). Merged into PERMISSION_IMPLIES in ./access.ts.
 */
import type { PermissionKey } from "@livingsyncs/types";

export const RESOURCE_WRITE_READ_IMPLIES: Partial<
  Record<PermissionKey, readonly PermissionKey[]>
> = {
  "adl-record:write": ["adl-record:read"],
  "analytics:write": ["analytics:read"],
  "appointment:write": ["appointment:read"],
  "appointment-form-rule:write": ["appointment-form-rule:read"],
  "appointment-type-definition:write": ["appointment-type-definition:read"],
  "audit:write": ["audit:read"],
  "audit-grant:write": ["audit-grant:read"],
  "audit-request:write": ["audit-request:read"],
  "auditor-group:write": ["auditor-group:read"],
  "auditor-invitation:write": ["auditor-invitation:read"],
  "bed-check-config:write": ["bed-check-config:read"],
  "bed-check-round:write": ["bed-check-round:read"],
  "billing-pack:write": ["billing-pack:read"],
  "calendar-event:write": ["calendar-event:read"],
  "care-note:write": ["care-note:read"],
  "care-plan:write": ["care-plan:read"],
  "case:write": ["case:read"],
  "case-template:write": ["case-template:read"],
  "emergency-contact:write": ["emergency-contact:read"],
  "employee:write": ["employee:read"],
  "external-provider:write": ["external-provider:read"],
  "facility:write": ["facility:read"],
  "form-requirement:write": ["form-requirement:read"],
  "form-submission:write": ["form-submission:read"],
  "form-template:write": ["form-template:read"],
  "group-home:write": ["group-home:read"],
  "holiday:write": ["holiday:read"],
  "incident:write": ["incident:read"],
  "invitation:write": ["invitation:read"],
  "legal-document:write": ["legal-document:read"],
  "medication:write": ["medication:read"],
  "notification:write": ["notification:read"],
  "permission:write": ["permission:read"],
  "pharmacy-partner:write": ["pharmacy-partner:read"],
  "request:write": ["request:read"],
  "resident:write": ["resident:read"],
  "resident-absence:write": ["resident-absence:read"],
  "resident-directory:write": ["resident-directory:read"],
  "role:write": ["role:read"],
  "rule-bundle:write": ["rule-bundle:read"],
  "rule-bundle-application:write": ["rule-bundle-application:read"],
  "shift:write": ["shift:read"],
  "subscription:write": ["subscription:read"],
  "training-assignment:write": ["training-assignment:read"],
  "training-completion:write": ["training-completion:read"],
  "training-material:write": ["training-material:read"],
  "user:write": ["user:read"],
  "vital-sign:write": ["vital-sign:read"],
  "webhook:write": ["webhook:read"],
};
